module.exports = {"IMAGE_WIDTH":545,"IMAGE_HEIGHT":545,"IMAGE_QUALITY":90,"COLORS_IMAGE_WIDTH":60,"COLORS_IMAGE_HEIGHT":90,"COLORS_IMAGE_QUALITY":90,"THUMBNAIL_IMAGE_WIDTH":100,"THUMBNAIL_IMAGE_HEIGHT":100,"THUMBNAIL_IMAGE_QUALITY":90}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/productDetail.json
// module id = 1365
// module chunks = 1